module.exports = __webpack_public_path__ + "static/media/Anivia_0.0da23d80.jpg";